import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { submitSuppotForm } from "../services/supportFormServices";

// Create initial states

const initialState = {
  supportform: {},
  loading: false,
  error: null,
  status: "idle",
};

// Create Thunk
export const submitSupportFormThunk = createAsyncThunk(
  "supportform/submitSuppotForm",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await submitSuppotForm(formData);
      return response.data; // Assuming the data is in response.data
    } catch (error) {
      return rejectWithValue(error.message); // Handle errors
    }
  }
);

// createSlice and handle cases
const suppotFormSlice = createSlice({
  name: "suppotform",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitSupportFormThunk.pending, (state) => {
        state.loading = true;
        state.status = "loading";
        state.error = null;
      })
      .addCase(submitSupportFormThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "submited";
        state.supportform = action.payload;
      })
      .addCase(submitSupportFormThunk.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default suppotFormSlice.reducer;
